<template>
	<div id="detailtop">
		<div class="ml">
			<ul style="float:left;" v-show="isshow">
					<li v-for="(item,index) in iteminfo" :key="index" @click="Details(item.title)">
							<a >{{item.title}}</a>
							<div class="ml1">
									<img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/gzs.png" alt="">
									<p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px; color: rgb(124, 122, 122);">国度工作室</p>
									<img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/rl.png" alt="">
									<p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">{{item.date | filterdate}}</p>
									<img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/ml.png" alt="">
									<p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">{{item.about}}</p>
							</div>
							<div class="ml2" >
									<a >阅读全文</a>
							</div>
					</li>   
			</ul>
			<div class="ml3">
				 <ul>
							<li>
									<a >热门资讯</a>
							</li>
							<li v-for="(item,index) in news" :key="index">
									<a :href="item.url" style="font-size: 15px; border: none; " >{{index+1+'.'+item.title}}</a>
							</li>
				 </ul>
			</div> 
		</div>
	</div>
</template>

<script>
	import {getnavinfo} from 'network/home'
	
	export default{
		name:'detailtop',
		props:{
			iteminfo:{
				type:Array,
				default:[]
			},
		},
		data(){
			return{
				news:[],
				isshow:true
			}
		},
		
		//1是防止后端检测不到分页报错
		created() {
			getnavinfo('热门资讯').then(res =>{
				this.news.push(...res.data.msg)
			})
		},
		methods:{
			Details(index){
				this.$emit('routerpush',index)
			}
		}
	}
</script>

<style scoped>
	/* 编程工具 */
	.ml{
	    /* border: solid 2px #000000; */
	    height: 900px;
	}
	.ml ul li{
			padding-top: 10px;
	    border-bottom: solid 2px #c0c0c0;
	    margin-top: 5px;
	    height: 70px;
	    width: 720px;
	    font-weight: bold;
	}
	.ml ul li a{
	    text-decoration: none;
	    letter-spacing:1px;
	    margin-left: 20px;
	}
	.ml1{
	    /* border: solid 2px #000000; */
	    width: 680px;
	    float: left;
	}
	.ml2{
	    float: right;
	    width: 100px;
	    height: 20px;
	    border: solid 2px #8d8d8d;
	    font-size: 15px;
	    margin-top: -18px;
	
	}
	
	.ml3{
	    width: 400px;
	    /* border: solid 2px #303030; */
	    float: right;
	    
	}
	.ml3 ul li{
	    background: none;
	    width: 400px;
	    height: 40px;
	    line-height: 40px;
	    border: none;
	    margin-bottom: 5px;
	    text-align: center;
	    border-bottom: solid 2px #c0c0c0;
	    
	}
	.ml3 ul li a{
	    width: 100px;
	    height: 40px;
	    font-size: 25px;
	}
	
	
	
	.banqq{
	    width: 100%;
	    height: 240px;
	    background: #2b2a2a;
	    position: absolute;
	    right:0px;
	}
	.ml ul li a:link{
	    color: rgb(63, 63, 63);
	}
	.ml ul li a:visited{
	    color: rgb(73, 73, 73);
	}
	.ml ul li a:hover{
	    text-decoration: underline;
	    color: rgb(53, 176, 247);
	}
	.ml ul li:hover{
	    background: lavender;
	}
	.ml3 ul li:hover{
	    background: none;
	}
	
</style>